// Lightweight meta-tag updater — no react-helmet dependency.
// Injects/updates <title>, meta description, canonical, OG tags, and a single
// JSON-LD script. Works with modern SEO crawlers that execute JS (Googlebot,
// GPTBot, PerplexityBot) AND with pre-rendering middleware if added later.

export function setMeta({ title, description, canonical, image, jsonLd, keywords } = {}) {
  if (title) document.title = title;

  const upsert = (sel, create, attrs) => {
    let el = document.head.querySelector(sel);
    if (!el) {
      el = create();
      document.head.appendChild(el);
    }
    Object.entries(attrs).forEach(([k, v]) => { if (v != null) el.setAttribute(k, v); });
    return el;
  };

  if (description) {
    upsert('meta[name="description"]', () => document.createElement('meta'), { name: 'description', content: description });
    upsert('meta[property="og:description"]', () => document.createElement('meta'), { property: 'og:description', content: description });
    upsert('meta[name="twitter:description"]', () => document.createElement('meta'), { name: 'twitter:description', content: description });
  }
  if (keywords) {
    upsert('meta[name="keywords"]', () => document.createElement('meta'), { name: 'keywords', content: keywords });
  }
  if (title) {
    upsert('meta[property="og:title"]', () => document.createElement('meta'), { property: 'og:title', content: title });
    upsert('meta[name="twitter:title"]', () => document.createElement('meta'), { name: 'twitter:title', content: title });
  }
  if (canonical) {
    upsert('link[rel="canonical"]', () => document.createElement('link'), { rel: 'canonical', href: canonical });
    upsert('meta[property="og:url"]', () => document.createElement('meta'), { property: 'og:url', content: canonical });
  }
  if (image) {
    upsert('meta[property="og:image"]', () => document.createElement('meta'), { property: 'og:image', content: image });
    upsert('meta[name="twitter:image"]', () => document.createElement('meta'), { name: 'twitter:image', content: image });
    upsert('meta[name="twitter:card"]', () => document.createElement('meta'), { name: 'twitter:card', content: 'summary_large_image' });
  }

  // Keep the page-specific JSON-LD slot single — update or create
  let ld = document.getElementById('page-jsonld');
  if (jsonLd) {
    if (!ld) {
      ld = document.createElement('script');
      ld.type = 'application/ld+json';
      ld.id = 'page-jsonld';
      document.head.appendChild(ld);
    }
    ld.textContent = JSON.stringify(jsonLd);
  } else if (ld) {
    ld.textContent = '';
  }
}
